// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87')
];

export const server_loads = [0,3,4,5,6,7,9];

export const dictionary = {
		"/": [10],
		"/about": [25],
		"/account/delete": [~26],
		"/admin": [~27,[3]],
		"/admin/accounts": [~28,[3]],
		"/admin/accounts/[userId]": [~29,[3,4]],
		"/admin/accounts/[userId]/audit": [~30,[3,4]],
		"/admin/accounts/[userId]/keys": [~31,[3,4]],
		"/admin/accounts/[userId]/ledger": [~32,[3,4]],
		"/admin/accounts/[userId]/scans": [~33,[3,4]],
		"/admin/accounts/[userId]/sessions": [~34,[3,4]],
		"/admin/accounts/[userId]/topups": [~35,[3,4]],
		"/admin/audit": [~36,[3]],
		"/admin/comments": [~37,[3]],
		"/admin/money": [~38,[3,5]],
		"/admin/money/anomalies": [~39,[3,5]],
		"/admin/money/deposits": [~40,[3,5]],
		"/admin/money/rates": [~41,[3,5]],
		"/admin/money/top-accounts": [~42,[3,5]],
		"/admin/ops": [~43,[3,6]],
		"/admin/ops/jobs": [~44,[3,6]],
		"/admin/ops/routes": [~45,[3,6]],
		"/admin/ops/services": [~46,[3,6]],
		"/admin/ops/storage": [~47,[3,6]],
		"/admin/password": [48,[3]],
		"/admin/scans": [~49,[3]],
		"/admin/scans/[id]": [~50,[3]],
		"/admin/status": [~51,[3]],
		"/admin/system": [~52,[3]],
		"/app": [~53,[7],[8]],
		"/app/analytics": [~54,[7],[8]],
		"/app/impersonation/stop": [~55,[7],[8]],
		"/app/keys": [~56,[7],[8]],
		"/app/scans/[id]": [~57,[7],[8]],
		"/app/settings": [~58,[7],[8]],
		"/app/top-ups": [~59,[7],[8]],
		"/app/top-ups/[id]": [~60,[7],[8]],
		"/app/upload": [61,[7],[8]],
		"/blog": [~62],
		"/blog/[slug]": [~63],
		"/blog/[slug]/comments": [~64],
		"/compare": [65],
		"/contact": [66],
		"/data-processing": [67],
		"/document-field-explorer": [68],
		"/error-probe": [69,[9]],
		"/error-probe/client": [70,[9]],
		"/error-probe/server": [~71,[9]],
		"/forgot-password": [~72],
		"/free-passport-ocr-api": [73],
		"/login": [~74],
		"/logout": [~75],
		"/mcp": [76],
		"/mrz-checker": [77],
		"/mrz-formats": [78],
		"/mrz-generator": [79],
		"/passport-ocr": [80],
		"/pricing": [~81],
		"/privacy": [82],
		"/register": [~83],
		"/reset-password": [~84],
		"/status": [~85],
		"/terms": [86],
		"/verify": [~87],
		"/[lang=locale]": [12,[2]],
		"/[lang=locale]/blog": [~14,[2]],
		"/[lang=locale]/blog/[slug]": [~15,[2]],
		"/[lang=locale]/blog/[slug]/comments": [~16,[2]],
		"/[lang=locale]/compare": [17,[2]],
		"/[lang=locale]/free-passport-ocr-api": [18,[2]],
		"/[lang=locale]/mcp": [19,[2]],
		"/[lang=locale]/mrz-checker": [20,[2]],
		"/[lang=locale]/mrz-formats": [21,[2]],
		"/[lang=locale]/mrz-generator": [22,[2]],
		"/[lang=locale]/pricing": [23,[2]],
		"/[lang=locale]/registro-de-viajeros-hoteles": [24,[2]],
		"/[lang=locale]/[country]-passport-ocr": [13,[2]],
		"/[country]-passport-ocr": [11]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);